import { SCHEME_MANIFESTS } from "./manifests";
import { familyPortalTheme } from "./portalTheme";
import { contrastRatio, relativeLuminance } from "./contrast";
const DEFAULT_SHELL_SCHEME = "care";
export const SHELL_DANGER = "#B3261E";
export const SHELL_ON_DANGER = "#FFFFFF";
const MIN_BRAND_CONTRAST = 4.5;
const luminanceOf = relativeLuminance;
const contrastOf = contrastRatio;
function schemeKey(value) {
    return value && value in SCHEME_MANIFESTS
        ? value
        : DEFAULT_SHELL_SCHEME;
}
function chosen(value) {
    return typeof value === "string" && value.trim() !== ""
        ? value.trim()
        : undefined;
}
export function supplierShellTheme(brand) {
    var _a;
    const ignored = [];
    const ground = chosen(brand === null || brand === void 0 ? void 0 : brand.bg);
    const wantedInk = chosen(brand === null || brand === void 0 ? void 0 : brand.ink);
    const accent = chosen(brand === null || brand === void 0 ? void 0 : brand.accent);
    const key = schemeKey(brand === null || brand === void 0 ? void 0 : brand.scheme);
    const resolve = (palette) => familyPortalTheme({
        key,
        ...(Object.keys(palette).length > 0 ? { tokens: { palette } } : {}),
    });
    const legibleInkFor = (bg) => { var _a; return ((_a = luminanceOf(bg)) !== null && _a !== void 0 ? _a : 1) > 0.4 ? "#111111" : "#FFFFFF"; };
    let theme = resolve({
        ...(ground ? { bg: ground } : {}),
        ...(wantedInk ? { ink: wantedInk } : {}),
        ...(accent ? { accent } : {}),
    });
    const readable = contrastOf(theme.ink, theme.paper);
    if (readable !== null && readable < MIN_BRAND_CONTRAST) {
        if (wantedInk) {
            ignored.push({ field: "ink", reason: "unreadable_on_background" });
        }
        theme = resolve({
            ...(ground ? { bg: ground } : {}),
            ink: legibleInkFor(theme.paper),
            ...(accent ? { accent } : {}),
        });
    }
    return {
        ...theme,
        danger: SHELL_DANGER,
        onDanger: SHELL_ON_DANGER,
        logoUrl: (_a = chosen(brand === null || brand === void 0 ? void 0 : brand.logoUrl)) !== null && _a !== void 0 ? _a : null,
        ignored,
    };
}
